import {
  ExcursionItem,
  CruiseExcursionsListProps
} from "src/page-components/cruise/itinerary/CruiseExcursionsList";
import { match } from "ts-pattern";

export const shorexCategorySubtitle = (category: string) =>
  match(category.toLowerCase().trim())
    .with("highlights experiences", () => "Seamless tours of iconic sites")
    .with("signature experiences", () => "Smaller tours, crafted by Silversea")
    .with("private experiences", () => "Exclusive tours for your group")
    .with("custom experiences", () => "Tailor-made tours designed for you")
    .with("overland experiences", () => "Mid-cruise, inland tours")
    .otherwise(() => undefined);

export const groupShorexesPerCategory = (
  shorexModels: ExcursionItem[]
): CruiseExcursionsListProps["excursions"] => {
  const groups = Object.groupBy(shorexModels, ({ category }) => category);
  const shorexesList = Object.entries(groups)
    .map(([category, shorexes]) => ({
      title: category,
      items: shorexes || []
    }))
    .sort((a, b) => a.title.localeCompare(b.title));

  return shorexesList;
};
